// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shareMethodField{margin-top:0;margin-bottom:1.1rem}.shareMethodField ul{padding-left:0 !important}.shareMethodField .info-popover__icon{margin-bottom:0 !important}.shareMethodField #popover-arrow-sms-tooltip{left:24px !important}.shareMethodField #popover-sms-tooltip-container{left:30px !important}.shareMethodField .tooltipIcon{margin-bottom:2px}.radioField{transform:scale(0.82)}", ""]);
// Exports
module.exports = exports;
